import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import api from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";

export default function RequestsBrowse() {
  const [params] = useSearchParams();
  const [city, setCity] = useState(params.get("city") || "");
  const [list, setList] = useState([]);
  const load = () => api.get("/booking-requests", { params: { city: city || undefined } }).then(({ data }) => setList(data)).catch(() => setList([]));
  useEffect(() => { load();   }, []);
  return (
    <div className="bg-slate-50 min-h-[calc(100vh-4rem)]">
      <div className="max-w-6xl mx-auto px-4 md:px-8 py-10">
        <div className="hw-label text-blue-700">Lead Marketplace</div>
        <h1 className="hw-head text-4xl md:text-5xl font-black text-slate-900 mt-3">Open booking requests</h1>
        <p className="text-slate-600 mt-2">Hotels: submit bids on requests in your city. Customers: see what others are asking for.</p>

        <div className="mt-6 flex gap-3 max-w-md">
          <Input data-testid="browse-city-input" value={city} onChange={(e) => setCity(e.target.value)} placeholder="Filter by city" className="rounded-sm" />
          <Button onClick={load} className="bg-emerald-600 hover:bg-emerald-700 text-slate-900 rounded-sm font-bold" data-testid="browse-filter-btn">Filter</Button>
        </div>

        {list.length === 0 ? (
          <div className="hw-card p-10 mt-8 text-center text-slate-600">No open requests right now.</div>
        ) : (
          <div className="grid md:grid-cols-2 gap-4 mt-8" data-testid="browse-requests-list">
            {list.map((r) => (
              <Link to={`/requests/${r.request_id}`} key={r.request_id} className="hw-card p-6 hover:hw-shadow-pop transition-all hover:-translate-y-0.5 block" data-testid={`browse-req-${r.request_id}`}>
                <div className="flex items-start justify-between">
                  <div>
                    <h3 className="hw-head font-bold text-xl text-slate-900">{r.city} · {r.rooms_needed} rooms</h3>
                    <div className="text-sm text-slate-500">{r.checkin} → {r.checkout}</div>
                  </div>
                  <span className="hw-chip border-emerald-300 bg-emerald-50 text-blue-700">{r.event_type}</span>
                </div>
                <p className="text-sm text-slate-600 mt-3">{r.notes}</p>
                {r.budget_per_room && <div className="hw-label text-slate-500 mt-3">Budget ₹{r.budget_per_room}/room</div>}
                <div className="hw-label text-blue-700 mt-4">Submit bid →</div>
              </Link>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
